import { render } from "./ProjectDetailsv2.vue?vue&type=template&id=43fe73ef"
import script from "./ProjectDetailsv2.vue?vue&type=script&lang=js"
export * from "./ProjectDetailsv2.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__